import { PageKey } from '../enums/pageKey';

export const PREMIUM_FEATURES = [
  PageKey.summativeTest,
  PageKey.dailyLessonLog,
  PageKey.unitPlan,
  PageKey.lessonPlan,
];
